module.exports = __webpack_public_path__ + "static/img/深蹲.4cb31839.png";